export default __webpack_public_path__ + "static/media/Default-Profile-pic.bff608ed.svg";